import WKD from '@openpgp/wkd-client';
import * as openpgp from 'openpgp';

class EncryptionForm extends HTMLElement {
  bindEvents() {
    this.$fileUpload.addEventListener('change', this.handleSelect.bind(this));
  }

  bindUI() {
    this.$fileDownloadList = this.querySelector('[data-ref="$fileDownloadList"]');
    this.$fileUpload = this.querySelector('[data-ref="$fileUpload"]');
    this.$form = this.querySelector('form');
  }

  connectedCallback() {
    this.setVars();
    this.bindUI();
    this.bindEvents();

    this.getBitGoKeys();
  }

  async getBitGoKeys() {
    const wkd = new WKD();
    const keyEmails = [
      'kyc1@bitgo.com',
      'kyc2@bitgo.com',
      'kyc4@bitgo.com',
      'kyc5@bitgo.com',
      'kyc6@bitgo.com',
      'kyc7@bitgo.com',
      'kyc8@bitgo.com',
      'kyc9@bitgo.com',
      'kyc10@bitgo.com',
      'staff@bitgo.com',
    ];

    for (const email of keyEmails) {
      let publicKeyBytes;
      try {
        publicKeyBytes = await wkd.lookup({email: email});
      } catch (error) {
        continue;
      }

      let key;
      try {
        key = await openpgp.readKey({binaryKey: publicKeyBytes});
      } catch (binaryError) {
        try {
          key = await openpgp.readKey({armouredKey: publicKeyBytes});
        } catch (armouredError) {
          continue;
        }
      }

      const expirationTime = await key.getExpirationTime();
      if (expirationTime && expirationTime < Date.now()) {
        continue;
      }

      this.publicKeys.push(key);
    }
  }

  /**
   * @param {string} filename
   */
  handleDownload(filename) {
    const file = this.files.find((file) => file.name === filename);
    if (!file) {
      return;
    }

    const reader = new FileReader();

    /**
     * @param {ProgressEvent} event
     */
    reader.onload = async (event) => {
      const fileArray = new Uint8Array(event.target.result);
      const message = await openpgp.createMessage({binary: fileArray, format: 'binary'});
      const encryptionOptions = {
        message,
        encryptionKeys: this.publicKeys,
        format: 'binary',
      };

      const encrypted = await openpgp.encrypt(encryptionOptions);
      const encryptedBlob = new Blob([encrypted], {
        type: 'application/pgp-encrypted',
      });
      const encryptedFile = window.URL.createObjectURL(encryptedBlob);
      const downloadLink = document.createElement('a');
      downloadLink.href = encryptedFile;
      downloadLink.download = `${file.name}.pgp`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    reader.readAsArrayBuffer(file);
  }

  /**
   * @param {Event} event
   */
  handleSelect(event) {
    event.preventDefault();
    this.files = [...event.target.files];

    this.update();
  }

  setVars() {
    /** @type {File[]} */
    this.files = [];

    /** @type {string[]} */
    this.publicKeys = [];
  }

  update() {
    if (this.files?.length > 0) {
      this.$fileDownloadList.innerHTML = '';

      this.files.forEach((file) => {
        const $downloadButton = document.createElement('button');
        $downloadButton.classList.add('btn');
        $downloadButton.textContent = `Download encrypted "${file.name}.pgp"`;
        $downloadButton.type = 'button';

        $downloadButton.addEventListener('click', () => this.handleDownload(file.name) );

        const $listItem = document.createElement('li');
        $listItem.appendChild($downloadButton);

        this.$fileDownloadList.appendChild($listItem);
      });
    } else {
      this.$fileDownloadList.innerHTML = '';
    }

    // Set attributes that drive UI state
    this.setAttribute('files-uploaded', this.files?.length > 0);
  }
}

if (!customElements.get('encryption-form')) {
  customElements.define('encryption-form', EncryptionForm);
}
